import styled from 'styled-components';

export const SelectWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  max-width: 260px;
`;
